"use client";

import { useWindowScroll } from "@mantine/hooks";

import useGetDownloadLink    from "_common/hooks/useGetDownloadLink";
import AnimateSlideEffect    from "_components/atoms/animateSlideEffect";
import { SNG_DOWNLOAD_LINK } from "_config/index";

function X2410MWebDownloadPage4 ( props ) {
	const {
		subtraction1341,
		downloadApp1
	} = props;

	const downloadLink  = useGetDownloadLink ();
	const downloadAppFn = () => {
		window.open ( downloadLink, "_blank" );
	};

	const [ scroll ] = useWindowScroll ();

	return (
		<AnimateSlideEffect change = { scroll.y > 200 }>
			<div className = "group-9761-3 border-1px-mercury">
				<button className = "download-app-btn-2"
					onClick          = { downloadAppFn }
				>
					<div className = "group-9287-7">
						<div className = "group-9-6">
							<div className = "group-9-6-2">
								<img className = "subtraction-134-7"
									src           = { subtraction1341 }
								/>
							</div>
						</div>
					</div>

					<div className = "download-app-12 montserrat-bold-white-16px">
						{downloadApp1}
					</div>
				</button>
			</div>
		</AnimateSlideEffect>
	);
}

export default X2410MWebDownloadPage4;
